import { render, staticRenderFns } from "./index-annullata.vue?vue&type=template&id=720bf622&"
import script from "./index-annullata.vue?vue&type=script&lang=js&"
export * from "./index-annullata.vue?vue&type=script&lang=js&"
import style0 from "./index-annullata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports